import {useId, useState, type ReactNode} from "react";
import {Input} from "@/components/ui/input.tsx";
import type Combatant from "@/encounter/model/Combatant.ts";
import {useCombatants} from "@/encounter/combatants/CombatantHooks.ts";
import CombatantEditDialog from "./CombatantEditDialog.tsx";

export default function EditNameDialog({combatant, children}: {combatant: Combatant; children?: ReactNode}) {
    const {update} = useCombatants();
    const [name, setName] = useState(combatant.name);
    const inputId = useId();
    return <CombatantEditDialog title="Name anpassen" description="Der Combatant-Name ist unabhängig vom Charakter-Namen."
        trigger={children ?? <button type="button" aria-label="Combatant-Namen bearbeiten"
            className="max-w-full cursor-pointer truncate text-left text-lg font-semibold hover:underline">{combatant.name}</button>}
        onOpen={() => setName(combatant.name)}
        validate={() => !name.trim() ? "Bitte gib einen Namen ein." : undefined}
        onSave={() => update([{...combatant, name: name.trim()}], "confirmed")}>
        <label htmlFor={inputId} className="block space-y-2 text-sm">Name
            <Input id={inputId} value={name} required onChange={event => setName(event.target.value)}/>
        </label>
    </CombatantEditDialog>;
}
